// Central icon file for inline SVGs used in CourseDetails and other UI
export const ClockIcon = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    width={20}
    height={20}
    {...props}
  >
    <circle cx="10" cy="10" r="9" stroke="#2B6A7F" strokeWidth="2" />
    <path
      d="M10 5v5l3 3"
      stroke="#2B6A7F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlayIcon = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    width={20}
    height={20}
    {...props}
  >
    <circle cx="10" cy="10" r="9" stroke="#2B6A7F" strokeWidth="2" />
    <polygon points="8,6 15,10 8,14" fill="#2B6A7F" />
  </svg>
);

export const QuizIcon = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    width={20}
    height={20}
    {...props}
  >
    <rect
      x="3"
      y="3"
      width="14"
      height="14"
      rx="3"
      stroke="#2B6A7F"
      strokeWidth="2"
    />
    <circle cx="10" cy="10" r="2" fill="#2B6A7F" />
  </svg>
);

export const PdfIcon = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    width={20}
    height={20}
    {...props}
  >
    <rect
      x="3"
      y="3"
      width="14"
      height="14"
      rx="2"
      stroke="#2B6A7F"
      strokeWidth="2"
    />
    <path d="M7 7h6v6H7z" fill="#2B6A7F" />
  </svg>
);
